<template>
  <VueQueryDevtools :client="queryClient" />
  <v-app id="app-wrapper">
    <SoBanner v-if="mockPermissions.enabled" type="success">
      <b class="font-weight-medium">Selected roles</b>:
      {{
        mockPermissions.roles.length
          ? mockPermissions.roles.join(", ")
          : "none"
      }}. Click
      <a href="javascript:;" @click="mockPermissions.enabled = false">here</a>
      to reset.
    </SoBanner>
    <v-layout>
      <TheNavBar />
      <router-view name="navigationDrawer"></router-view>
      <NotAuthorised v-if="unauthorised" />
      <router-view v-else name="view"></router-view>
    </v-layout>
  </v-app>
  <SoSnackbar />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useSnackbarStore } from "@/stores/snackbar"
  import { useThemeHelper } from "@/theme/themeHelper"
  import { useAuthorisation } from "@/composables/authorisation"
  import { useMockPermissionsStore } from "@/stores/mockPermissions"
  import { VueQueryDevtools } from "@tanstack/vue-query-devtools"
  import { queryClient } from "@/api/utils/useQuery"
  import SoBanner from "@/components/SoBanner.vue"
  import TheNavBar from "@/components/navigation/TheNavBar.vue"
  import SoSnackbar from "@/components/SoSnackbar.vue"
  import NotAuthorised from "@/views/NotAuthorised.vue"
  import { themeOptions } from "@/constants/themeOptions"

  export default defineComponent({
    components: {
      TheNavBar,
      NotAuthorised,
      SoBanner,
      SoSnackbar,
      VueQueryDevtools,
    },
    // eslint-disable-next-line vue/component-api-style
    setup() {
      const { unauthorised } = useAuthorisation()
      return { unauthorised, queryClient }
    },
    data() {
      return {
        snackbar: useSnackbarStore(),
        theme: useThemeHelper(),
        mockPermissions: useMockPermissionsStore(),
      }
    },
    mounted() {
      this.theme.name =
        window.localStorage.getItem(themeOptions.LOCAL_STORAGE_KEY) ??
        this.theme.name
    },
  })
</script>
